export const SET_OPEN_MENU = 'set_open_menu';
export const SET_IMAGE_GROUP = 'set_image_group';
export const SET_IMAGE_HEADER = 'set_image_header';
export const SET_DATA_FIELD = 'set_data_field';
export const SET_USER_POINT = 'set_user_point';
export const SET_CONTRIBUTION_CHOICE_ADMIN = 'set_contribution_choice_admin';
